import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface EmbededChatWindowProps {
  onClose: () => void
  chatToken: string
  patientId: string
  patientName: string
  householdId: string
  patientState: string
  patientPhoneNumber: string
}

const EmbededChatWindow = ({
  onClose,
  chatToken,
  patientId,
  patientName,
  householdId,
  patientState,
  patientPhoneNumber,
}: EmbededChatWindowProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { t, i18n } = useTranslation()
  const lang = i18n.language

  return (
    <div
      className={`
            fixed
            flex
            flex-col
            md:relative 
            ${isExpanded ? 'md:h-[min(768px,80vh)] md:w-[660px]' : 'md:w-[300px]'}
            bottom-0 
            left-0 
            z-50 
            h-dvh 
            w-full 
            rounded-t-xl 
            bg-white 
            shadow-[0_0_24px_0_rgba(0,0,0,0.15)] 
            md:left-auto
            md:h-[min(480px,80vh)]
            md:rounded-xl
        `}
    >
      <div className='flex shrink-0 items-center justify-between rounded-t-xl bg-[#0F687C] p-4'>
        <p
          className='text-sm font-semibold text-white'
          data-testid='embeded-chat-title'
        >
          {t('chat_with_provider')}
        </p>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className='hidden md:block'
          data-testid='embeded-chat-expand-button'
        >
          <img
            src='/images/expand.svg'
            alt='expand'
            className='h-6 w-6'
          />
        </button>
        <button
          onClick={onClose}
          className='text-white md:hidden'
          data-testid='embeded-chat-close-button'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            strokeWidth={1.5}
            stroke='currentColor'
            className='h-6 w-6'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              d='M6 18L18 6M6 6l12 12'
            />
          </svg>
        </button>
      </div>

      {chatToken && (
        <iframe
          title='Chat iframe'
          className='grow'
          src={`${import.meta.env.VITE_WEBCHAT_URL}?lang=${lang}&userId=${patientId}&userName=${patientName}&householdId=${householdId}&phoneNumber=${patientPhoneNumber}&patientState=${patientState}&token=${chatToken}`}
        />
      )}
    </div>
  )
}

export default EmbededChatWindow
